import { createContext, useContext, useLayoutEffect } from "react";

export interface RouteStatusVisibility {
  /** False while the app bootstrap loader still covers the page. */
  revealed: boolean;
  /** Registers a mounted 404/403 page with the loader; returns the unregister. */
  register: () => () => void;
}

const noRegistration = () => () => undefined;

const RouteStatusVisibilityContext = createContext<RouteStatusVisibility>({
  revealed: true,
  register: noRegistration,
});

export const RouteStatusVisibilityProvider = RouteStatusVisibilityContext.Provider;

/**
 * Announces a confirmed error page before the first paint, so the loader's
 * minimum hold ends without a covered frame, and reports whether the page is
 * visible yet so its entrance can wait for it.
 */
export function useRouteStatusVisibility(): boolean {
  const { revealed, register } = useContext(RouteStatusVisibilityContext);
  useLayoutEffect(register, [register]);
  return revealed;
}
